<app-dialog-heading [heading]='this.heading'></app-dialog-heading>

<div>
    <mat-grid-list cols="1" rowHeight="75px">
      <mat-grid-tile *ngIf="isEdit">
        <app-content-field [label]="'Payment ID'"
                           [content]="paymentId"></app-content-field>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Payment Reference</mat-label>
          <input type="text" matInput [formControl]="paymentReferenceFormControl" required>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Payment Reference')">help_outline
        </mat-icon>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Payment Completion Date</mat-label>
          <input [formControl]="completionDateFormControl"
                 [matDatepicker]="completionDatePicker" matInput required>
          <mat-datepicker-toggle [for]="completionDatePicker" matIconSuffix>
          </mat-datepicker-toggle>
          <mat-datepicker #completionDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-icon [matTooltip]="getInfoTooltip('Payment Completion Date')" class="info-icon">help_outline</mat-icon>
      </mat-grid-tile>

    </mat-grid-list>
  
  
  <div *ngIf="!isEdit" class="m-b-20">
    <label class="mat-primary-color" style="font-size: small;">
      Are you sure you want to mark this claim as paid? This is not
      reversible as the claim will no longer be editable once done.</label>
  </div>

  <div class="dialog-button-container">
    <button class="dialog-button" mat-raised-button color="warn" (click)="onCancelClick()">Cancel</button>
    <button class="dialog-button"
            mat-raised-button color="primary"
            [disabled]="disableSaveButton()"
            (click)="onSaveClick()">
      Save
      <app-busy-spinner-icon [isBusyCounter]="isBusyCounterInlineSpinner"></app-busy-spinner-icon>
    </button>
  </div>
</div>
